<template>
  <el-container>
    <el-header class="header">
      <div class="title">
        <span class="name">{{ $title }}</span>
      </div>
      <div class="rightSetting">
        <router-link
          :to="{ name: 'AddUser', query: { id: user_id } }"
          class="nameImg"
          v-loading="loading"
          v-if="$store.getters.authority({ name: 'workbench', type: 'add' })"
        >
          <img
            v-if="!$store.state.login.userInfo.image_url"
            v-bind:src="Pimage"
            style="width: 50px; height: 50px; border-radius: 100%"
          />
          <img
            v-if="$store.state.login.userInfo.image_url"
            v-bind:src="$store.state.login.userInfo.image_url"
            style="width: 50px; height: 50px; border-radius: 100%"
          />
        </router-link>
        <router-link
          :to="{ name: '' }"
          class="nameImg"
          v-loading="loading"
          v-else
        >
          <img
            v-if="!$store.state.login.userInfo.image_url"
            v-bind:src="Pimage"
            style="width: 50px; height: 50px; border-radius: 100%"
          />
          <img
            v-if="$store.state.login.userInfo.image_url"
            v-bind:src="$store.state.login.userInfo.image_url"
            style="width: 50px; height: 50px; border-radius: 100%"
          />
        </router-link>
        <router-link
          :to="{ name: 'AddUser', query: { id: user_id } }"
          class="thatName"
          v-if="$store.getters.authority({ name: 'workbench', type: 'add' })"
          >{{ $store.state.login.userInfo.name }}</router-link
        >
        <router-link :to="{ name: '' }" class="thatName" v-else
          >{{ $store.state.login.userInfo.name }}
        </router-link>

        <!-- <el-button class="cirBtn settingBtn" type="text" icon="el-icon-setting" circle @click="rightShowAside = !rightShowAside"></el-button> -->
        <div style="display: inline-block">
          <img
            style="position: absolute; bottom: 15px"
            src="./../assets/images/a.png"
            @click="binding"
            alt=""
          />
        </div>
        <div style="display: inline-block">
          <img
            style="position: absolute; bottom: 15px; right: 120px"
            src="./../assets/images/b.png"
            @click="toBindUrl"
            alt=""
          />
        </div>

        <!-- <div><img src="./../assets/images/a.png" alt=""></div> -->
        <!-- <el-button size="small" @click="binding">绑定</el-button>  -->
        <el-button
          class="cirBtn outBtn"
          type="text"
          icon="el-icon-close"
          @click="outAdmin"
          >退出</el-button
        >
      </div>
    </el-header>
    <el-container class="elCon">
      <el-aside
        width="200px"
        class="aside"
        style="background-color: rgba(57, 61, 73, 1)"
      >
        <el-menu
          v-for="(item, index) in menuList"
          :key="index"
          router
          :index="index"
          menu-trigger="click"
          :unique-opened="true"
          background-color="#393d49"
          text-color="#fff"
          class="menuActive"
          active-text-color="#fff"
        >
          <el-menu-item
            :index="item.url"
            v-if="item.auth"
            v-show="$store.getters.getUserInfo.comm_terminal && (  $store.getters.getUserInfo.role !='POINT_PARTNER' && $store.getters.getUserInfo.role !='点位合作商') "
          >
            <i class="megex-icon menu-icon"  v-show="item.auth" :class="item.icon"></i>
            <span class="i-title"   v-show="item.auth">{{ item.title }}</span>
          </el-menu-item>
          <el-menu-item
            index="/index/mengniubench"
            v-show="$store.getters.getUserInfo.monitor"
          >
            <i class="megex-icon menu-icon" :class="item.icon"></i> 监测柜工作台
          </el-menu-item>
          <el-submenu
            :index="secondeIndex"
            v-for="(lists, secondeIndex) in item.list"
            
            :key="secondeIndex"
            v-show="filterThree(lists.threeArr)"
          >
            <template slot="title">
              <i class="megex-icon menu-icon" :class="lists.icon"></i>
              <span slot="title" class="list-title">{{ lists.title }}</span>
            </template>
            <el-menu-item-group sub-group no-action>
              <el-menu-item
                :index="threeList.url"
                v-for="(threeList, threeIndex) in lists.threeArr"
                :key="threeIndex"
                v-show="threeList.auth"
                dense
              >
                <span class="three-list">{{ threeList.small_title }}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main class="Main">
        <el-scrollbar style="height: calc(100vh - 100px)">
          <router-view />
        </el-scrollbar>
      </el-main>
      <transition name="show">
        <el-aside v-show="rightShowAside" width="300px" class="rightAside">
          <div class="settPass">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <ul class="smallWrap">
                <li class="passLi">
                  <div class="passSty">旧密码</div>
                  <el-form-item prop="passOne">
                    <el-input
                      maxlength="20"
                      v-model="ruleForm.passOne"
                      type="password"
                      placeholder
                    ></el-input>
                  </el-form-item>
                </li>
                <li class="passLi">
                  <div class="passSty">新密码</div>
                  <el-form-item prop="password">
                    <el-input
                      maxlength="20"
                      v-model="ruleForm.password"
                      type="password"
                      placeholder
                    ></el-input>
                  </el-form-item>
                </li>
                <li class="passLi">
                  <div class="passSty">确认密码</div>
                  <el-form-item prop="checkPass">
                    <el-input
                      maxlength="20"
                      v-model="ruleForm.checkPass"
                      type="password"
                      placeholder
                    ></el-input>
                  </el-form-item>
                </li>
                <li class="passLi flexSpace">
                  <el-button
                    class="xPassBtn"
                    type="primary"
                    @click="modifyBtn('ruleForm')"
                    >修改密码</el-button
                  >
                  <el-button class="canchBtn" @click="cancahBtn"
                    >取消</el-button
                  >
                </li>
              </ul>
            </el-form>
          </div>
        </el-aside>
      </transition>
    </el-container>
    <el-dialog
      title="绑定中亚售货机账号"
      :visible.sync="bindingVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span></span>
      <el-form label-width="80px" :model="formLabelAlign">
        <el-form-item label="账号">
          <el-input v-model="formLabelAlign.loginname"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            type="password"
            v-model="formLabelAlign.password"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindingVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindingVisibleConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import apis from "@/config/apis";
import mouse from "@/assets/images/Image.jpg";
// router/index.ts
// import store from './store' // 假设权限在 store 里
import { mapState } from "vuex";
export default {

  
  data() {


    
    var checkPassOne = (rule, value, callback) => {
      if (!value) {
        callback(new Error("密码不能为空"));
      } else {
        let regs = /^[0-9a-zA-Z_]*$/;
        if (!regs.test(value)) {
          callback(new Error("只允许数字、字母、下划线"));
        }
        if (value.length < 6) {
          callback(new Error("密码长度不小于6位数"));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("密码不能为空"));
      } else {
        let regs = /^[0-9a-zA-Z_]*$/;
        if (!regs.test(value)) {
          callback(new Error("只允许数字、字母、下划线"));
        }
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        if (value.length < 6) {
          callback(new Error("密码长度不小于6位数"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("确认密码不能为空"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      formLabelAlign: {
        loginname: "",
        password: "",
      },
      _allData:[],
      bindingVisible: false,
      bindUrl: "",
      role: "",
      commRole: "",
      advert: "",
      profit: "",
      menuList: [],
      mengniuList: [],
      allList: [],
      loading: false,
      rightShowAside: false,
      user_id: this.$store.state.login.userInfo.user_id,
      Pimage: mouse,
      rel_name: "",
      headportrait: "headportrait",
      password: "password",
      dianwei:'',
      shebei:'',
      tiaojia:"",
      bizId:"",
      userId:"",
      lihuo:"",
      workbench:"",
      ruleForm: {
        passOne: "",
        password: "",
        checkPass: "",
      },
      rules: {
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        passOne: [
          {
            required: true,
            validator: checkPassOne,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    console.log("登录成功了");
    console.log(this.$store.getters.getUserInfo.comm_terminal,'$store.getters.getUserInfo.comm_terminal')
    console.log(this.$store.getters.getUserInfo,'this.$store.getters.getUserInfo.role === "VISITOR"')
    this.formLabelAlign.loginname = localStorage.getItem("loginname");
    this.userId = localStorage.getItem("user_id");



    this.$axios.get(apis.get_user).then((res) => {
      this.profit = res.data.data.profitsharing;
    });
  },
  activated() {
    const data =  JSON.parse(localStorage.getItem('pc_permission'));
    this._allData = data;
    console.log(data,'datadatadatadata')

    // this.workbench = data;
   this.dianwei= data.some(item => item.name === "点位合作商订单列表");
   this.shebei =data.some(item => item.name === "点位合作商设备列表");
   this.tiaojia = data.some(item => item.name === "商品调价策略");
   this.workbench = data.some(item => item.name === "工作台");
   this.lihuo = data.some(item => item.name === "理货任务")
   console.log(this.lihuo,'this.lihuo')

   console.log(this.item)

    
    //  }

    let that = this;
    setTimeout(function () {
      that.getMenuList();
    }, 0);
  },
  methods: {
    binding() {
      this.bindingVisible = true;
    },
    bindingVisibleConfirm() {
      let jsonData = {
        loginname: this.formLabelAlign.loginname,
        password: this.formLabelAlign.password,
      };
      this.$axios.post(apis.bind, jsonData).then((res) => {
        if (res.data.code == 200) {
          this.bindUrl = res.data.data.url;
          localStorage.setItem("bindUrl", res.data.data.url);
          this.$message({
            message: "绑定成功",
            type: "success",
          });
          this.bindingVisible = false;
        }
      });
    },
    toBindUrl() {
      let url = localStorage.getItem("bindUrl");
      window.location.href = url;
    },
    getMenuList() {
      this.menuList = [
        {
          index: "/",
          url: this.$store.getters.getUserInfo.role == '点位合作商' ? "/index/deviceMangement" : "/index/workbench",
          title: "工作台",
          icon: "megex-gongzuotai",
          auth: this.workbench == true,
          list: [
            {
              title: "签约管理",
              icon: "megex-qianyue",
              threeArr: [
                {
                  url: "/index/contract",
                  small_title: "合同管理",
                  auth: this.$store.getters.authority({
                    name: "contract",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "广告管理",
              icon: "megex-guanggao",
              threeArr: [
                {
                  url: "/index/applyAdList",
                  small_title: "广告申请",
                  auth:
                    this.$store.getters.authority({
                      name: "applyAd",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.advert,
                },
                {
                  url: "/index/examine",
                  small_title: "审核列表",
                  auth:
                    this.$store.getters.authority({
                      name: "examine",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.advert,
                },
                {
                  url: "/index/advertisement",
                  small_title: "广告列表",
                  auth:
                    this.$store.getters.authority({
                      name: "advertisement",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.advert,
                },
                {
                  url: "/index/advertisingdelivery",
                  small_title: "广告投放",
                  auth:
                    this.$store.getters.authority({
                      name: "advertisingdelivery",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.advert,
                },
              ],
            },
            {
              title: "设备管理",
              icon: "megex-shebeiguanli",
              threeArr: [
                {
                  url: "/index/CabinetMangement",
                  small_title: "货柜管理",
                  auth: this.$store.getters.authority({
                    name: "cabinetManage",
                    type: "view",
                  }),
                },
                {
                  url: "/index/InventoryManagement",
                  small_title: "盘点记录",
                  auth: this.$store.getters.authority({
                    name: "inventoryManagement",
                    type: "view",
                  }),
                },
                {
                  url: "/index/deviceMangement",
                  small_title: "点位合作商设备列表",
                  auth: this.$store.getters.authority({
                    name: "inventoryManagement",
                    type: "view",
                  }) && this.shebei.length>0,
                },
                
                // {
                //     url: "/index/StockMangement",
                //     small_title: "备货管理",
                //     auth: this.$store.getters.authority({
                //         name: "stockManage",
                //         type: "view",
                //     }),
                // },
                {
                  url: "/index/ReplenishmentMangement",
                  small_title: "补货记录",
                  auth: this.$store.getters.authority({
                    name: "replenishManage",
                    type: "view",
                  }),
                },
                {
                  url: "/index/PointMangement",
                  small_title: "点位管理",
                  auth: this.$store.getters.authority({
                    name: "pointManage",
                    type: "view",
                  }),
                },
                {
                  url: "/index/PointType",
                  small_title: "点位类型",
                  auth: this.$store.getters.authority({
                    name: "pointTypeManage",
                    type: "view",
                  }),
                },
                {
                  url: "/index/LineMangement",
                  small_title: "线路管理",
                  auth: this.$store.getters.authority({
                    name: "lineManage",
                    type: "view",
                  }),
                },
               {
                  url: "/index/restock",
                  small_title: "理货任务",
                     auth:  this.lihuo.length>0,
                },
                // {
                //     url: "/index/machineAudit",
                //     small_title: "机器审核",
                //     auth: this.$store.getters.getUserInfo.special_user,
                // },
              ],
            },
            {
              title: "分级管理",
              icon: "megex-fenji",
              threeArr: [
                {
                  url: "/index/gradeSetting",
                  small_title: "分级设置",
                  auth: this.$store.getters.getUserInfo.special_user,
                },
                {
                  url: "/index/gradeView",
                  small_title: "分级显示",
                  auth: this.$store.getters.getUserInfo.special_user,
                },
                {
                  url: "/index/gradeAudit",
                  small_title: "分级审核",
                  auth: this.$store.getters.getUserInfo.special_user,
                },
              ],
            },
            // {
            //   title: "监测柜管理",
            //   icon: "megex-shebeiguanli",
            //   threeArr: [
            //     {
            //       url: "/index/inspection",
            //       small_title: "货柜管理",
            //       auth:
            //         this.$store.getters.authority({
            //           name: "mengniuInspection",
            //           type: "view",
            //         }) && this.$store.getters.getUserInfo.monitor,
            //     },
            //     {
            //       url: "/index/area",
            //       small_title: "大区管理",
            //       auth:
            //         this.$store.getters.authority({
            //           name: "mengniuArea",
            //           type: "view",
            //         }) && this.$store.getters.getUserInfo.monitor,
            //     },
            //     {
            //       url: "/index/region",
            //       small_title: "区域管理",
            //       auth:
            //         this.$store.getters.authority({
            //           name: "mengniuRegion",
            //           type: "view",
            //         }) && this.$store.getters.getUserInfo.monitor,
            //     },
            //     {
            //       url: "/index/point",
            //       small_title: "点位管理",
            //       auth:
            //         this.$store.getters.authority({
            //           name: "mengniuPoint",
            //           type: "view",
            //         }) && this.$store.getters.getUserInfo.monitor,
            //     },
            //     {
            //       url: "/index/inventorydetails",
            //       small_title: "库存变化明细",
            //       auth:
            //         this.$store.getters.authority({
            //           name: "mengniuInventorydetails",
            //           type: "view",
            //         }) && this.$store.getters.getUserInfo.monitor,
            //     },
            //   ],
            // },
            {
              title: "订单管理",
              icon: "megex-dingdanguanli",
              threeArr: [
                {
                  url: "/index/openRecord",
                  small_title: "开门记录表",
                  auth: this.$store.getters.authority({
                    name: "openRecord",
                    type: "view",
                  }),
                },
                {
                  url: "/index/interfaceUsageList",
                  small_title: "接口使用列表",
                  auth: this.$store.getters.authority({
                    name: "interfaceUsage",
                    type: "view",
                  }),
                },
                {
                  url: "/index/OrderMangement",
                  small_title: "货柜订单",
                  auth: this.$store.getters.authority({
                    name: "order",
                    type: "view",
                  }),
                },
                {
                  url: "/index/cooperation",
                  small_title: "点位合作商订单列表",
                  auth: this.$store.getters.authority({
                    name: "joint",
                    type: "view",
                  }) && this.dianwei.length>0,
                },
                
              
                {
                  url: this.userId == 42 ? "/index/JointMangement":'',
                  small_title: this.userId == 42 ?"联合查询" :'',
                  auth: this.$store.getters.authority({
                    name: "joint",
                    type: "view",
                  }),
                },
              ].filter(item => item.url && item.small_title),
            },

            {
              title: "商品管理",
              icon: "megex-shangpinguanli",
              threeArr: [
                // {
                //   url: "/index/shoppingCategory",
                //   small_title: "商品分类",
                //   auth: this.$store.getters.authority({
                //     name: "shopCategory",
                //     type: "view",
                //   }),
                // },
                // {
                //   url: "/index/shoppingManage",
                //   small_title: "商品列表",
                //   auth: this.$store.getters.authority({
                //     name: "shopManage",
                //     type: "view",
                //   }),
                // },
                {
                  url: "/index/goodsGroup",
                  small_title: "商品识别分组",
                  auth: this.$store.getters.authority({
                        name: "goodsGroup",
                        type: "view",
                    }),
                },
                // {
                //     url: "/index/goodsRecognitionRate",
                //     small_title: "分组识别率",
                //     auth: this.$store.getters.authority({
                //         name: "goodsRecognitionRate",
                //         type: "view",
                //     }),
                // },
                {
                  url: "/index/shoppingModel",
                  small_title: "模板管理",
                  auth: this.$store.getters.authority({
                    name: "shopModel",
                    type: "view",
                  }),
                },
                 {
                  url: "/index/unifiedPrice",
                  small_title: "商品调价策略",
                  auth: this.$store.getters.authority({
                    name: "shopModels",
                    type: "view",
                  }) && this.tiaojia == true,
                },
              ],
            },
            {
              title: "分账管理",
              icon: "megex-zhangdan",
              threeArr: [
                {
                  url: "/index/splitBillList",
                  small_title: "待分账列表",
                  auth:
                    this.$store.getters.authority({
                      name: "splitBill",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.profitsharing,
                },
                {
                  url: "/index/splitBillAlreadyList",
                  small_title: "已分账列表",
                  auth:
                    this.$store.getters.authority({
                      name: "splitBill",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.profitsharing,
                },
                {
                  url: "/index/splitBillConfigList",
                  small_title: "分账配置",
                  auth:
                    this.$store.getters.authority({
                      name: "splitBill",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.profitsharing,
                },
              ],
            },
            {
              title: "营销管理",
              icon: "megex-yingxiao",
              threeArr: [
                // {
                //   url: "/index/ActivityMangement",
                //   small_title: "优惠券管理",
                //   auth: this.$store.getters.authority({
                //     name: "activetyManage",
                //     type: "view",
                //   }),
                // },
                // {
                //   url: "/index/discountManagement",
                //   small_title: "打折管理",
                //   auth: this.$store.getters.authority({
                //     name: "discount",
                //     type: "view",
                //   }),
                // },
                {
                  url: "/index/QRcodeMangement",
                  small_title: "二维码管理",
                  auth: this.$store.getters.authority({
                    name: "qrcodeManage",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "财务管理",
              icon: "megex-caiwuguanli",
              threeArr: [
                {
                  url: "/index/finance",
                  small_title: "提现管理",
                  auth: this.$store.getters.authority({
                    name: "finance",
                    type: "view",
                  }),
                },
                // {
                //     url: "/index/voucherManage",
                //     small_title: "凭证管理",
                //     auth: true,
                // },
                {
                  url: "/index/balanceList",
                  small_title: "余额列表",
                  // auth: true,
                  auth: this.$store.getters.authority({
                    name: "balanceList",
                    type: "view",
                  }),
                },
                {
                  url: "/index/financeAuditList",
                  small_title: "提现审核",
                  auth: this.$store.getters.authority({
                    name: "financeAudit",
                    type: "view",
                  }),
                },
                {
                  url: "/index/transactionTotal",
                  small_title: "交易汇总(日)",
                  auth: this.$store.getters.authority({
                    name: "tradeDetail",
                    type: "view",
                  }),
                },
                {
                  url: "/index/transactionSummary",
                  small_title: "交易汇总(月)",
                  auth: this.$store.getters.authority({
                    name: "tradeDetail",
                    type: "view",
                  }),
                },
                {
                  url: "/index/dimensionList",
                  small_title: "分账列表",
                  // auth: true,
                  auth: this.$store.getters.authority({
                    name: "dimensionList",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "用户管理",
              icon: "megex-yunweiguanli",
              threeArr: [
                {
                  url: "/index/UserList",
                  small_title: "角色列表",
                  auth: this.$store.getters.authority({
                    name: "userList",
                    type: "view",
                  }),
                },
                {
                  url: "/index/UserMangement",
                  small_title: "系统用户",
                  auth: this.$store.getters.authority({
                    name: "systemUser",
                    type: "view",
                  }),
                },
                {
                  url: "/index/PointCooperationPartners",
                  small_title: "运营点位绑定",
                  auth: this.$store.getters.authority({
                    name: "systemUser",
                    type: "view",
                  }),
                },
                // {
                //     url: "/index/replenishMangement",
                //     small_title: "补货员管理",
                //     auth: this.$store.getters.authority({
                //         name: "replenishmenter",
                //         type: "view",
                //     }),
                // },
              ],
            },
            {
              title: "监测柜数据分析",
              icon: "megex-shujufenxi",
              threeArr: [
                {
                  url: "/index/inspectionDA",
                  small_title: "分组汇总表",
                  auth:
                    this.$store.getters.authority({
                      name: "mengniuInspectionDA",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.monitor,
                },
                {
                  url: "/index/goods",
                  small_title: "商品明细表",
                  auth:
                    this.$store.getters.authority({
                      name: "mengniuGoods",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.monitor,
                },
                {
                  url: "/index/sales",
                  small_title: "销售情况分析",
                  auth:
                    this.$store.getters.authority({
                      name: "mengniuSales",
                      type: "view",
                    }) && this.$store.getters.getUserInfo.monitor,
                },
              ],
            },
            {
              title: "会员管理",
              icon: "megex-huiyuanguanli",
              threeArr: [
                {
                  url: "/index/memberList",
                  small_title: "会员列表",
                  auth: this.$store.getters.authority({
                    name: "memberManage",
                    type: "view",
                  }),
                },
                // {
                //   url: "/index/memberRemain",
                //   small_title: "余额记录",
                //   auth: this.$store.getters.authority({
                //     name: "memberManage",
                //     type: "view",
                //   }),
                // },
                {
                  url: "/index/suggestion",
                  small_title: "意见反馈",
                  auth: this.$store.getters.authority({
                    name: "suggestion",
                    type: "view",
                  }),
                },
                {
                  url: "/index/reportFailure",
                  small_title: "上报故障",
                  auth: this.$store.getters.authority({
                    name: "reportFailure",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "数据分析",
              icon: "megex-shujufenxi",
              threeArr: [
                {
                  url: "/index/transactionDA",
                  small_title: "交易分析",
                  auth: this.$store.getters.authority({
                    name: "DA",
                    type: "view",
                  }),
                },
                {
                  url: "/index/memberDA",
                  small_title: "会员分析",
                  auth: this.$store.getters.authority({
                    name: "DA",
                    type: "view",
                  }),
                },
                {
                  url: "/index/shopDA",
                  small_title: "商品分析",
                  auth: this.$store.getters.authority({
                    name: "DA",
                    type: "view",
                  }),
                },
                {
                  url: "/index/tradeAreaDA",
                  small_title: "线路分析",
                  auth: this.$store.getters.authority({
                    name: "DA",
                    type: "view",
                  }),
                },
                {
                  url: "/index/marketDA",
                  small_title: "营销分析",
                  auth: this.$store.getters.authority({
                    name: "DA",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "报表管理",
              icon: "megex-dingdanguanli",
              threeArr: [
                {
                  url: "/index/openStatistics",
                  small_title: "开门统计表",
                  auth: this.$store.getters.authority({
                    name: "openStatistics",
                    type: "view",
                  }),
                },
                {
                  url: "/index/goodsSell",
                  small_title: "商品销售表",
                  auth: this.$store.getters.authority({
                    name: "openStatistics",
                    type: "view",
                  }),
                },
                // {
                //   url: "/index/goodsStatistics",
                //   small_title: "商品统计表",
                //   auth: this.$store.getters.authority({
                //     name: "goodsStatistics",
                //     type: "view",
                //   }),
                // },
                {
                  url: "/index/goodsDailysales",
                  small_title: "每日销售额表",
                  auth: this.$store.getters.authority({
                    name: "goodsDailysales",
                    type: "view",
                  }),
                },
              ],
            },
            {
              title: "系统管理",
              icon: "megex-xitongguanli",
              threeArr: [
                {
                  url: "/index/logMangement",
                  small_title: "日志管理",
                  auth: this.$store.getters.authority({
                    name: "log",
                    type: "view",
                  }),
                },
                {
                  url: "/index/loginMangement",
                  small_title: "登陆管理",
                  auth:true,
                  // auth: this.$store.getters.authority({
                  //   name: "loginMangement",
                  //   type: "view",
                  // }),
                },
                {
                  url: "/index/pushMangement",
                  small_title: "推送管理",
                  auth:true,
                  // auth: this.$store.getters.authority({
                  //   name: "pushMangement",
                  //   type: "view",
                  // }),
                },
                {
                  url: "/index/helpdocument",
                  small_title: "帮助文档",
                  auth: this.$store.getters.authority({
                    name: "document",
                    type: "view",
                  }),
                },
                {
                  url: "/index/systemSetting",
                  small_title: "系统设置",
                  auth: this.$store.getters.authority({
                    name: "systemSetting",
                    type: "view",
                  }),
                },
              ],
            },
          ],
        },
      ];
    },
    // filterThree(list) {
    //     const result = list.every(function(item) {
    //         return item.auth === false;
    //     });
    //     return !result;
    // },
    filterThree(list) {
    //   console.log(list);
      let pc = JSON.parse(localStorage.getItem("pc_permission"));
    //   console.log(pc);
      let arr = [];
      pc.forEach((item) => {
        let has = list.find((i) => i.small_title === item.name);
        has ? arr.push(has) : "";
      });
      arr.forEach((item) => {
        item.auth = true;
      });
      const result = arr.every(function (item) {
        return item.auth === false;
      });
      return !result;
    },

    outAdmin() {
      this.rightShowAside = false;
      window.localStorage.clear(); //退出清缓存
      // localStorage.setItem("bindUrl","");
      // localStorage.setItem("loginname","");
      // localStorage.setItem("monitor", "");
      // localStorage.setItem("comm_terminal", "");
      // localStorage.setItem("token", "");
      this.$router
        .push({
          path: "/login",
        })
        .then((res) => {
          // console.log(res);
          // window.localStorage.clear()  //退出清缓存
          window.location.reload();
        });
    },
    modifyBtn(forName) {
      this.$refs[forName].validate((valid) => {
        if (valid) {
          let jsonData = {
            old_password: Base64.encode(this.ruleForm.passOne),
            new_password: Base64.encode(this.ruleForm.password),
          };
          let url = `${apis.userImage}/${this.$store.getters.getUserInfo.user_id}/${this.password}`;
          this.$axios.put(url, jsonData).then((data) => {
            if (data.data.code == 200) {
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
              this.ruleForm.passOne = "";
              this.ruleForm.password = "";
              this.ruleForm.checkPass = "";
              this.rightShowAside = false;
            } else {
              this.$message({
                message: "密码修改错误",
                type: "warning",
              });
            }
          });
        }
      });
      //   if(this.passYz()) return false;
      //    this.rightShowAside = false;
    },
    cancahBtn() {
      this.rightShowAside = false;
      this.passOne = "";
      this.passTwo = "";
      this.passThree = "";
    },
  },
  
};
</script>

<style lang="scss" scoped>
.menu-icon {
  font-size: 20px;
  margin-right: 12px;
}

.header {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
  position: fixed;
  width: 100%;
  min-width: 1200px;
  z-index: 2;
  .title {
    /*width:200px;*/
    margin: 17px 0;
    text-align: center;
    display: inline-block;
  }
  .name {
    color: #333;
    font-size: 21px;
    font-weight: bold;
    display: inline-block;
    vertical-align: middle;
  }
  .version {
    display: inline-block;
    padding: 5px 12px;
    margin-left: 12px;
    background: #009688;
    color: #fff;
    border-radius: 10px;
    font-size: 12px;
    font-weight: normal;
    vertical-align: middle;
  }
  .rightSetting {
    float: right;
    /*width:300px;*/
    height: 60px;
    line-height: 56px;
    .nameImg {
      width: 50px;
      height: 50px;
      border-radius: 100%;
      display: inline-block;
      vertical-align: middle;
      background: #fff;
      border: 1px solid gray;
    }
    .thatName {
      padding: 0 30px;
      color: #666;
    }
    .cirBtn {
      vertical-align: middle;
    }
    .settingBtn {
      font-size: 28px;
      padding: 0px;
      color: gray;
    }
    .outBtn {
      color: #666;
      font-size: 15px;
      margin-left: 45px;
    }
  }
}

.aside {
  position: fixed;
  top: 60px;
  bottom: 0;
  z-index: 1;
  /*height:calc(100vh - 60px);*/
}

.Main {
  margin: 60px 0 0 200px;
  padding: 20px 5px 20px 20px;
  min-width: 1080px;
}

.rightAside {
  background: #fff;
  position: fixed;
  right: 0px;
  top: 60px;
  bottom: 0;
  z-index: 3;
  border-left: 1px solid rgba(0, 0, 0, 0.13);
  .settPass {
    .smallWrap {
      width: 80%;
      margin: 40px auto 0;
    }
    .passSty {
      padding-bottom: 12px;
      color: #333;
    }
    .passLi {
      margin-bottom: 12px;
    }
    .flexSpace {
      display: flex;
      justify-content: space-between;
      .xPassBtn,
      .canchBtn {
        width: 44%;
      }
    }
  }
}

/*动画*/

.show-enter-active,
.show-leave-active {
  transition: all 0.5s;
}

.show-enter {
  right: -300px;
}

.show-leave-to {
  right: -300px;
}

/*fixed*/

.rightFixed {
  position: fixed;
  right: -70px;
  bottom: 100px;
  z-index: 10;
  transition: all 0.5s linear;
  .fixed_li {
    cursor: pointer;
    text-align: center;
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.5);
    margin-bottom: 6px;
    .flex_info {
      display: block;
      font-size: 13px;
      color: #e4e4e4;
      padding-top: 6px;
    }
    .icon {
      margin-top: 15px;
    }
    .mouseWrap {
      display: none;
      position: absolute;
      right: 100%;
      top: -194px;
      z-index: 3;
    }
    .weChatMouse {
      top: -104px;
      .smallMouse {
        width: 90%;
        .mouseTitle {
          margin-top: 15px;
          .icon-weChatLogo {
            margin-top: 0;
            vertical-align: middle;
          }
          .t_info {
            vertical-align: middle;
            font-size: 14px;
            margin-left: 10px;
            font-weight: bold;
          }
        }
        .codeWrap {
          width: 134px;
          height: 134px;
          margin: 10px auto;
          .codeWin {
            width: 100%;
          }
        }
        .wrapFooter {
          font-size: 14px;
        }
      }
    }
    &:hover {
      .mouseWrap {
        display: block;
      }
    }
  }
  &:hover {
    right: 0;
  }
}
</style>

<style lang="scss">
.aside {
  .el-menu {
    border-right: 0;
  }
}

.menuActive {
  .el-menu-item.is-active {
    background-color: #409eff !important;
  }
}
.list-title {
  font-weight: 900;
  color: #f0ffff;
}
.three-list {
  padding-left: 12px;
  color: rgba(255, 255, 255, 0.8);
}
.i-title {
  font-weight: 900;
  color: #f0ffff;
}
</style>
